import { render, staticRenderFns } from "./articleTitle.vue?vue&type=template&id=a4429a2e&scoped=true&"
import script from "./articleTitle.vue?vue&type=script&lang=js&"
export * from "./articleTitle.vue?vue&type=script&lang=js&"
import style0 from "./articleTitle.vue?vue&type=style&index=0&id=a4429a2e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4429a2e",
  null
  
)

export default component.exports